import { render, staticRenderFns } from "./searchedRecords.html?vue&type=template&id=60616212&scoped=true&external"
import script from "./searchedRecords.js?vue&type=script&lang=js&external"
export * from "./searchedRecords.js?vue&type=script&lang=js&external"
import style0 from "./searchedRecords.scss?vue&type=style&index=0&id=60616212&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60616212",
  null
  
)

export default component.exports